module.exports = __webpack_public_path__ + "img/cb1edf8.png";